// extracted by mini-css-extract-plugin
module.exports = {"template":"Templates-module--template--3lNBF","selected":"Templates-module--selected--18pA4"};